import React from 'react';
import axios from 'axios';
import { Form, Input, DatePicker, Upload, Alert, Row, Col, Icon } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import DictionarySelect from 'components/DictionarySelect';
import formItemLayout from 'components/Portal/formItemLayout';
import withSpin from 'components/withSpin';
import passport from 'components/passportUtils';
import stickyError from 'components/stickyError';
import SaveButton from 'components/SaveButton';
import StandardSteps from 'components/StandardSteps';
import StatusRadioGroup from 'components/StatusRadioGroup';
import PassportModal from './PassportModal';
import PassPhoto from 'images/PassPhotoExample.jpg';
import PassExample from 'images/PassExample.jpg';

class PassportDetails extends React.Component {
	state = {
		scan: null,
		photo: null,
		oldfolio: {}
	}
	//function to check the size and file type of the media upload
	beforeUpload = (file) => {
		const isJPG = file.type === 'image/jpeg';
		if (!isJPG) {
		  stickyError("You can only upload JPG file!")
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
		  stickyError("Image must be smaller than 2MB!")
		}
		return isJPG && isLt2M;
	  }

	handleUploadChange = (field, info) => {
		let s = {};
		s[field] = info.fileList.slice(-1);
		this.setState(s);
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.updateFolio(this.props.form, 'DocumentList')
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	refreshUpload = (field) => {
		const route = (field === 'scan') ? '/passport' : '/passportphoto';
		axios.get(apiPath+route, {withCredentials: true}).then(result => {
			if (result.data.length) {
				let s = {};
				s[field] = [{
					uid: 1,
					url: apiPath+route
				}];
				this.setState(s);
				this.props.refreshStatuses();
			}
		}).catch(this.props.handleAxiosLoadError);
	}
	componentWillMount() {
		// get passport details from resco
		axios.get(apiPath+'/oldfolio', {withCredentials: true}).then(result => {
			this.setState({ oldfolio: result.data });
			this.refreshUpload('scan');
			this.refreshUpload('photo');
		}).catch(this.props.handleAxiosLoadError);
	}
	
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'travel/passport');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'travel/passport');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		const passengerPassport = passport.parseFromFolio(this.state.oldfolio);
		const { Nationality } = this.state.oldfolio;
		const {
			DocumentId, IssueCountry, No, IssueDate, ExpiryDate
		} = passengerPassport;
		const uploadProps = {
			showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
			listType: 'picture-card',
			withCredentials: true
		};
		const fullyApproved = this.props.statusesLoaded &&
			this.props.statuses.SRI_CP_OF_PASSPORT === 'A' &&
			this.props.statuses.SRI_PPORT_SIZED_PHOTO === 'A';
		const passportApproved = this.props.statusesLoaded && this.props.statuses.SRI_CP_OF_PASSPORT === 'A';
		const photoApproved = this.props.statusesLoaded && this.props.statuses.SRI_PPORT_SIZED_PHOTO === 'A';
		
		return (
			<div>
				{fullyApproved && <p className="withSpacing">
					This section has been disabled because your passport information has been verified already<br /><br />
				</p>}
				<Alert showIcon type="warning"
					description="This is the passport number that will be used to book Field Programs. If this number is incorrect, or changes and you do not update it, you may not be able to participate in your Field Programs." />
				<br />
				<Alert showIcon type="warning"
					description={<span>If you have renewed your passport, have a second valid passport or are a dual citizen and have another passport, please send a scan of your passport to <a href="mailto:programadministration@isevoyages.org">programadministration@isevoyages.org</a>. It is our policy that all visas should be contained in a single passport."</span>} />
					<br />
				<Form onSubmit={this.handleSubmit}>
					<DictionarySelect
						required
						className="inResco"
						label="Nationality"
						code="CNT"
						field="Nationality"
						initialValue={Nationality || ''}
						formItemLayout={formItemLayout}
						getFieldDecorator={getFieldDecorator}
						disabled={disabled || fullyApproved} />
					{/* <DictionarySelect
						required
						className="inResco"
						label="Issuing Country"
						code="CNT"
						field="IssueCountry"
						initialValue={IssueCountry || ''}
						formItemLayout={formItemLayout}
						getFieldDecorator={getFieldDecorator}
						disabled={disabled || fullyApproved} /> */}
					<Form.Item label="Passport Number" className="inResco" {...formItemLayout}>
						{getFieldDecorator('No', {
							initialValue: No,
							rules: [{required: true, message: 'Passport number is required'}]
						})(
							<Input disabled={disabled || fullyApproved} />
						)}
					</Form.Item>
					<Form.Item label="Issue Date" className="inResco" {...formItemLayout}>
						{getFieldDecorator('IssueDate', {
							initialValue: IssueDate && moment.utc(IssueDate),
							rules: [{required: true, message: 'Issue date is required'}]
						})(
							<DatePicker disabled={disabled || fullyApproved} />
						)}
					</Form.Item>
					<Form.Item label="Expiry Date" className="inResco" {...formItemLayout}>
						{getFieldDecorator('ExpiryDate', {
							initialValue: ExpiryDate && moment.utc(ExpiryDate),
							rules: [{required: true, message: 'Expiry date is required'}]
						})(
							<DatePicker disabled={disabled || fullyApproved} />
						)}
					</Form.Item>
					{this.props.variant === 'admin' &&
						<Form.Item label="Birth Date" className="inResco" {...formItemLayout}>
							{getFieldDecorator('BirthDate', {
								initialValue: this.props.folio.BirthDate && moment.utc(this.props.folio.BirthDate),
								rules: [ {required: true, message: 'Birth Date is required'} ]
							})(
								<DatePicker disabled={disabled || fullyApproved} />
							)}
						</Form.Item>
					}
					<Form.Item style={{marginBottom:'0px'}}>
						{getFieldDecorator('Type', {
							initialValue: 'P'
						})(<Input type="hidden" />)}
					</Form.Item>
					<Form.Item style={{marginBottom:'0px'}}>
						{getFieldDecorator((DocumentId) ? 'DocumentId' : 'ExternalId', {
							initialValue: (DocumentId) ? DocumentId : 'P' + moment().format('x')
						})(<Input type="hidden" />)}
					</Form.Item>
					<Form.Item style={{marginBottom:'0px'}}>
						{getFieldDecorator('Type', {
							initialValue: 'P'
						})(<Input type="hidden" />)}
					</Form.Item>
					<SaveButton
						disabled={!this.props.form.isFieldsTouched()}
						loading={this.props.getStatus().submitting}
						buttonText="Save Details" />
				</Form>
				<legend>Uploads</legend>
				<Row style={{marginBottom:'24px'}}>
					<Col xs={24} sm={9}>Scan of your Passport: <br/> <br/> 
					<div style={{fontSize: '10px'}}>
					If your passport is marked "Incomplete" please check that it:
					<br/>	Is signed
					<br/> 	Includes the top signature page
					<br/>	All numbers and letters are clear and readable
					<br/>
					<br/>
					<PassportModal>
						<img src={PassExample} alt="Passport-Example" className="image"/> 
					</PassportModal>
					<br/>
					</div>
					</Col>
					<Col xs={24} sm={15}>
						<Upload
							disabled={disabled || !this.props.statusesLoaded || (this.props.variant !== 'admin' && passportApproved)}
							name="scan"
							action={apiPath+'/passport'}
							fileList={this.state.scan}
							beforeUpload={this.beforeUpload}
							onChange={this.handleUploadChange.bind(this, 'scan')}
							{... uploadProps}>
							<Icon type={(passportApproved) ? 'check' : 'upload'} />
							<div className="ant-upload-text">
								{(passportApproved) ? 'Approved' : (this.state.scan && this.state.scan.length) ? 'Overwrite' : 'Upload'}
							</div>
						</Upload>
						{this.props.variant === 'normal' &&
							<StandardSteps size="small"
								code={this.props.statusesLoaded && this.props.statuses.SRI_CP_OF_PASSPORT} />
						}
						{this.props.variant === 'admin' && this.props.statusesLoaded &&
							<div>
								Status:&nbsp;
								<StatusRadioGroup
									statusType="SRI_CP_OF_PASSPORT"
									onChange={this.props.handleStatusChange}
									value={this.props.statuses.SRI_CP_OF_PASSPORT} />
							</div>
						}
					</Col>
				</Row>
				<Row style={{marginBottom:'24px'}}>
					<Col xs={24} sm={9}>Passport Photo/I.D. Style Photo: <br/> <br/>
					<div style={{fontSize: '10px'}}>
					If your photo is marked "Incomplete" please check that it:
					<br/>	Is a picture that clearly identifies you (no hats, sunglasses etc..)
					<br/>	Is not a photo of the picture on your passport
					<br/>	Includes your face and shoulders 
					<br/>	Is taken against a neutral background
					<br/>
					<br/>
					<PassportModal>
						<img src={PassPhoto} alt="Passport-Photo-Example" className="image" height='594px' width='423px'/> 
					</PassportModal>
					</div>
					</Col>
					<Col xs={24} sm={15}>
						<Upload
							disabled={disabled || !this.props.statusesLoaded || (this.props.variant !== 'admin' && photoApproved)}
							name="photo"
							action={apiPath+'/passportphoto'}
							fileList={this.state.photo}
							beforeUpload={this.beforeUpload}
							onChange={this.handleUploadChange.bind(this, 'photo')}
							{... uploadProps}>
							<Icon type={(photoApproved) ? 'check' : 'upload'} />
							<div className="ant-upload-text">
								{(photoApproved) ? 'Approved' : (this.state.photo && this.state.photo.length) ? 'Overwrite' : 'Upload'}
							</div>
						</Upload>
						{this.props.variant === 'normal' &&
							<StandardSteps size="small"
								code={this.props.statusesLoaded && this.props.statuses.SRI_PPORT_SIZED_PHOTO} />
						}
						{this.props.variant === 'admin' && this.props.statusesLoaded &&
							<div>
								Status:&nbsp;
								<StatusRadioGroup
									statusType="SRI_PPORT_SIZED_PHOTO"
									onChange={this.props.handleStatusChange}
									value={this.props.statuses.SRI_PPORT_SIZED_PHOTO} />
							</div>
						}

					</Col>
				</Row>
			</div>
		);
	}
}

export default withSpin(Form.create()(PassportDetails));






// WEBPACK FOOTER //
// ./portal-components/Portal/Travel/PassportDetails.jsx